function getSiblings(el) {
  const siblings = [];
  let sibling = el.parentElement.firstElementChild;
  do {
    if (sibling.nodeType === 1 && sibling !== el) {
      siblings.push(sibling);
    }
    sibling = sibling.nextElementSibling;
  } while (sibling);
  return siblings;
}
function getClosest(elem, selector) {
  // Element.matches() polyfill
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
      var matches = (this.document || this.ownerDocument).querySelectorAll(s),
        i = matches.length;
      while (--i >= 0 && matches.item(i) !== this) {}
      return i > -1;
    };
  }

  // Get the closest matching element
  for (; elem && elem !== document; elem = elem.parentNode) {
    if (elem.matches(selector)) return elem;
  }
  return null;
}
function elementExists(element) {
  return typeof element !== "undefined" && element !== null;
}
function clickOutside(el, fn) {
  document.addEventListener("click", function (e) {
    if (e.target !== el && !el.contains(e.target)) {
      fn && fn(e);
    }
  });
}
function triggerChangeEvent(option) {
  // set selected property
  option.selected = true;

  // raise event on parent <select> element
  if ("createEvent" in document) {
    var evt = document.createEvent("HTMLEvents");
    evt.initEvent("change", false, true);
    option.parentNode.dispatchEvent(evt);
  } else {
    option.parentNode.fireEvent("onchange");
  }
}

/* A1 JS helper functions */

function formatAmount(amount) {
  let digit = Math.floor(amount + "e" + 2) + "e-" + 2;
  return parseFloat(digit).toLocaleString("sl-SI", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}
function scrollToElement(element, offset = 10) {
  let targetElement = null;
  if (element instanceof jQuery) {
    targetElement = element[0];
  } else if (element instanceof Element) {
    targetElement = element;
  } else {
    targetElement = rootElement.querySelector(element) || null;
  }
  if (!targetElement) return;
  let headerOffset = window.outerWidth < 576 ? 65 : 0;
  let bodyRect = document.body.getBoundingClientRect().top;
  let elementRect = targetElement.getBoundingClientRect().top;
  let elementPosition = elementRect - bodyRect;
  let offsetPosition = elementPosition - headerOffset - offset;
  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth"
  });
}

/**
 * Copyright (c) 2000-present Liferay, Inc. All rights reserved.
 *
 * This library is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Lesser General Public License as published by the Free
 * Software Foundation; either version 2.1 of the License, or (at your option)
 * any later version.
 *
 * This library is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Lesser General Public License for more
 * details.
 */

var A1Carousel = {
  init() {
    const flkty = new Flickity(".js-spc-carousel", {
      cellAlign: "left",
      contain: true,
      prevNextButtons: false,
      wrapAround: true,
      autoPlay: 5000
    });

    // elements
    const carouselNavigation = document.querySelector(".Spc-navigation");
    const navigationCells = Array.from(carouselNavigation.children);

    // update on select
    flkty.on("select", () => {
      const previousSelectedSlide = carouselNavigation.querySelector(".is-selected");
      const selectedSlide = carouselNavigation.children[flkty.selectedIndex];
      previousSelectedSlide.classList.remove("is-selected");
      selectedSlide.classList.add("is-selected");
    });
    carouselNavigation.addEventListener("click", event => {
      // @todo: matchesSelector polifyll
      //if (!matchesSelector(event.target, '.Spc-navigation-cell')) return

      const index = navigationCells.indexOf(event.target);
      flkty.select(index);
    });
  },
  initProductImagesSlideshow() {
    const flkty = new Flickity(".product-gallery", {
      cellSelector: ".gallery-cell",
      pageDots: false,
      contain: true,
      draggable: true
    });

    // elements
    const carouselNavigation = document.querySelector(".product-detail-header .images-list");
    const navigationCells = Array.from(carouselNavigation.children);

    // update on select
    flkty.on("select", () => {
      const previousSelectedSlide = carouselNavigation.querySelector(".active");
      const selectedSlide = carouselNavigation.children[flkty.selectedIndex];
      previousSelectedSlide.classList.remove("active");
      selectedSlide.classList.add("active");
    });
    carouselNavigation.addEventListener("click", event => {
      // @todo: matchesSelector polifyll
      //if (!matchesSelector(event.target, '.Spc-navigation-cell')) return
      const index = navigationCells.indexOf(event.target);
      flkty.select(index);
    });
  },
  initProductPreview() {
    const productListCarousels = document.querySelectorAll(".product-list-preview");
    productListCarousels.forEach(function (carousel) {
      new Flickity(carousel, {
        // options go here
        cellAlign: "left",
        cellSelector: ".flickity-cell",
        autoPlay: 5000,
        groupCells: true,
        contain: true,
        draggable: true
      });
    });
    $(".product-list-preview .flickity-cell").addClass("loaded");
  },
  initNavTabs() {
    const navTabsCarousels = document.querySelectorAll(".nav-tabs-flickity");
    navTabsCarousels.forEach(function (carousel) {
      new Flickity(carousel, {
        // options go here
        pageDots: false,
        prevNextButtons: false,
        cellAlign: "left",
        cellSelector: ".flickity-cell",
        contain: true
      });
    });
    $(".nav-tabs-flickity .flickity-cell").addClass("loaded");
  },
  initTariffCarousel(ctx) {
    const carousel = $(".tariff-list");
    const container = $(".tariff-list-container");
    const carouselItems = carousel.find(".tariff-list-item");

    // if more than 1 package and medium or less bootstrap width
    if (!carousel[0] || carouselItems.length < 2 || window.innerWidth > 974) return;
    carousel.removeClass("row");
    carousel.addClass("tariff-carousel");
    container.addClass("is-initialized");
    const flkty = new Flickity(carousel[0], {
      // options go here
      pageDots: true,
      prevNextButtons: true,
      cellAlign: "left",
      cellSelector: ".tariff-list-item",
      groupCells: true,
      contain: true,
      draggable: true,
      initialIndex: ctx && ctx.index ? ctx.index : 0
    });

    // elements
    const carouselNavigation = document.querySelector(".tariff-navigation");
    const navigationCells = carouselNavigation && carouselNavigation.children ? Array.from(carouselNavigation.children) : null;

    // update on select
    flkty.on("select", () => {
      const previousSelectedSlide = carouselNavigation.querySelector(".is-selected");
      const selectedSlide = carouselNavigation.children[flkty.selectedIndex];
      previousSelectedSlide.classList.remove("is-selected");
      selectedSlide.classList.add("is-selected");
    });
    if (navigationCells) {
      carouselNavigation.addEventListener("click", event => {
        let index = navigationCells.indexOf(event.target);
        if (index === -1) index = navigationCells.indexOf(event.target.parentElement);
        flkty.select(index);
      });
    }
  }
};

/* Listens to add to cart events, and shows loader on button */

class A1CartLoader {
  elements = null; // all button elements
  timeout = 45000; // timeout 45s - if there is no response enable back buttons
  timeoutHandler = null;
  loading = false; // state if add to cart is in process
  loadingButton = null;
  buttonOld = null;
  constructor(selector) {
    this.elements = document.querySelectorAll(selector);
    if (!this.elements) {
      console.warn(`[A1CartButtonLoader] Initialization failed. No DOM element found for selector: ${selector}.`);
      return;
    }
    this.init();
  }
  init() {
    /* Init add to cart events */
    this.elements.forEach(element => {
      element.addEventListener("click", this._handleAddToCart.bind(this));
    });

    /* Callback events */

    /* Added events */
    Liferay.on("a1secom.cart.moga.product.added", this._handleHideLoader.bind(this));
    Liferay.on("a1secom.cart.hwoi.product.added", this._handleHideLoader.bind(this));
    Liferay.on("a1secom.cart.net.product.added", this._handleHideLoader.bind(this));

    /* Failed events */
    Liferay.on("a1secom.cart.moga.product.failed", this._handleHideLoader.bind(this));
    Liferay.on("a1secom.cart.hwoi.product.failed", this._handleHideLoader.bind(this));
    Liferay.on("a1secom.cart.net.product.failed", this._handleHideLoader.bind(this));
  }
  _handleAddToCart(event) {
    if (this.loading) {
      event.preventDefault();
      Liferay.Util.openToast({
        message: "Dodajanje izdelka je že v teku.",
        type: "danger"
      });
      return;
    }
    this.loading = true;
    this.loadingButton = event.target;
    this.buttonOld = this.loadingButton.cloneNode(true);
    this.loadingButton.style.height = this.loadingButton.offsetHeight + "px";
    this.loadingButton.style.width = this.loadingButton.offsetWidth + "px";
    this.loadingButton.innerHTML = '<span aria-hidden="true" role="status" class="spinner-border spinner-border-sm"></span>';
    this.loadingButton.classList.add("is-loading");
    this.loadingButton.classList.remove("btn-arrow-right");
    this.loadingButton.classList.remove("btn-arrow-left");

    // sets auto timeout handler if no answer is given in time
    this.timeoutHandler = setTimeout(this._handleTimeoutLoader.bind(this), this.timeout);
  }
  _handleTimeoutLoader() {
    window.cartLoading = false;
    Liferay.Util.openToast({
      message: "Prišlo je do napake pri dodajanju izdelka v košarico. Prosimo poskusite kasneje.",
      type: "danger"
    });
    this._handleHideLoader();
  }
  _handleHideLoader() {
    if (!this.loading) return;
    this.loading = false;
    clearTimeout(this.timeoutHandler);
    this.loadingButton.classList = this.buttonOld.classList;
    this.loadingButton.innerHTML = this.buttonOld.innerHTML;
    this.loadingButton.style.height = null;
    this.loadingButton.style.width = null;
    this.buttonOld = null;
  }
}
var WS_SEgoHandler = {
  clickMuteMs: 2000,
  executingClickTime: Date.now(),
  chatLinkNotBound: document.querySelector("#ws-sego-chat-link:not(.bound)"),
  chatLink: document.querySelector("#ws-sego-chat-link"),
  init: function () {
    WS_SEgoHandler.initWizzardLink();
  },
  isSEgoPresent: function () {
    return typeof lpTag !== "undefined" && typeof lpTag === "object" && lpTag.loaded === true && lpTag.loaded == true && document.querySelector(".LPMcontainer");
  },
  showChatLink: function () {
    if (this.chatLink) {
      this.chatLink.classList.remove("hidden-important");
    }
  },
  hideChatLink: function () {
    if (this.chatLink) {
      this.chatLink.classList.add("hidden-important");
    }
  },
  updateValues: function () {
    this.chatLinkNotBound = document.querySelector("#ws-sego-chat-link:not(.bound)");
    this.chatLink = document.querySelector("#ws-sego-chat-link");
  },
  initWizzardLink: function () {
    WS_SEgoHandler.updateValues();
    if (WS_SEgoHandler.isSEgoPresent()) {
      if (this.chatLinkNotBound) {
        this.chatLinkNotBound.addEventListener("click", function (e) {
          var lastClick = Date.now(),
            muteClick = lastClick - WS_SEgoHandler.clickMuteMs < WS_SEgoHandler.executingClickTime;
          e.preventDefault();
          if (!muteClick) {
            WS_SEgoHandler.executingClickTime = lastClick;
            if (WS_SEgoHandler.isSEgoPresent()) {
              if (document.querySelector("[data-lp-point='minimize_icon']")) {
                document.querySelector("[data-lp-point='minimize_icon']").click();
              } else {
                if (document.querySelector(".LPMcontainer")) {
                  document.querySelector(".LPMcontainer").click();
                }
              }
            }
          }
        });
        this.chatLinkNotBound.classList.add("bound");
        WS_SEgoHandler.showChatLink();
      }
    } else {
      WS_SEgoHandler.hideChatLink();
    }
  }
};
WS_SEgoHandler.init();
function openAida() {
  if (typeof WS_SEgoHandler !== "undefined" && typeof WS_SEgoHandler === "object") {
    WS_SEgoHandler.init();
  }
  $("#ws-sego-chat-link")[0].click();
}
$(window).ready(function () {
  $(".contact-wizard-icon").on("click", function (event) {
    /*
    $(this)
      .closest(".contact-wizard")
      .toggleClass("opened");
     var toggleIcon = $("#toggle-wizard-icon");
    toggleIcon.toggleClass("a1icon-contact a1icon-close");
    */
    openAida();
  });
  let url = new URL(window.location.href);
  if (url.search.includes("openChat")) {
    setTimeout(function () {
      openAida();
    }, 4000);
  } else if (url.hash === '#aida') {
    setTimeout(function () {
      openAida();
    }, 4000);
  }
});
var A1Datepicker = {
  /* constructor(element) {
        this.rootElement = element
        this.init()
    }
    */

  init(elementId) {
    const calendarObject = {
      calendar: null,
      active: false,
      month: null,
      next: null,
      previous: null,
      label: null,
      activeDates: null,
      date: new Date(),
      todaysDate: new Date(),
      enableWeekends: false,
      init(elementId, enableWeekends = false) {
        this.calendar = document.querySelector("#" + elementId);
        this.isTouchDevice = "ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch;
        this.calendarContainer = this.calendar.querySelector(".Calendar-container");
        this.locatePlaceholders();
        this.date.setDate(1);
        this.createMonth();
        this.createMonthListeners();
        this.enableWeekends = enableWeekends;
        const {
          connectedId
        } = this.calendar.dataset;
        if (connectedId) {
          this.connectedCalendar = document.querySelector(`#${connectedId}`);
        }
        if (this.connectedCalendar) {
          const input = this.connectedCalendar.querySelector(".js-selectedDate");
          input.addEventListener("change", () => {
            this.openCalendar();
          });
        }
        this.input = this.calendar.querySelector(".js-selectedDate");
        if (this.input) {
          this.input.addEventListener(this.isTouchDevice ? "touchend" : "click", () => {
            if (this.input.classList.contains("is-active")) {
              this.closeCalendar();
            } else {
              this.openCalendar();
            }
          });
          var self = this;
          this.toggleBtn = this.calendar.querySelector(".Form-icon");
          this.toggleBtn.addEventListener("click", function () {
            self.toggleCalendar();
          });
          clickOutside(this.calendarContainer, e => {
            if (e.target === this.input || e.target === this.toggleBtn || this.toggleBtn.contains(e.target) || this.connectedCalendar && this.connectedCalendar.querySelector(".Calendar-container").contains(e.target)) {
              return;
            }
            this.closeCalendar();
          });
          this.input.addEventListener("input", () => {
            if (!this.input.value) {
              this.clearSelected();
            }
          });
        }
      },
      openCalendar() {
        this.calendarContainer.classList.remove("is-hidden");
        this.input.classList.add("is-active");
        this.active = true;
      },
      closeCalendar() {
        this.calendarContainer.classList.add("is-hidden");
        this.input.classList.remove("is-active");
        this.active = false;
      },
      toggleCalendar() {
        if (this.active) this.closeCalendar();else this.openCalendar();
      },
      locatePlaceholders() {
        this.month = this.calendar.querySelector(".js-month");
        this.next = this.calendar.querySelector(".js-nextMonth");
        this.previous = this.calendar.querySelector(".js-previousMonth");
        this.label = this.calendar.querySelector(".js-monthLabel");
      },
      createMonthListeners() {
        this.next.addEventListener("click", () => this.switchMonth("next"));
        this.previous.addEventListener("click", () => this.switchMonth("previous"));
      },
      weekOfMonth(date) {
        const firstWeekday = new Date(date.getFullYear(), date.getMonth(), 1).getDay();
        const offsetDate = date.getDate() + firstWeekday - 1;
        return Math.floor(offsetDate / 7);
      },
      lastDayOfMonth(date) {
        const temp = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return temp.getDate();
      },
      weekCount(date) {
        const firstOfMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        const lastOfMonth = new Date(date.getMonth(), date.getMonth(), 0);
        const used = firstOfMonth.getDay() + lastOfMonth.getDate();
        return Math.ceil(used / 7);
      },
      createDay(num, day, year) {
        const newDay = document.createElement("div");
        const dateEl = document.createElement("span");
        dateEl.innerHTML = num;
        newDay.className = "Calendar-date";
        newDay.setAttribute("data-calendar-date", num);
        if (day === 0) day = 7;
        if (num === 1) {
          const offset = (day - 1) * 14.28;
          if (offset > 0) newDay.style.marginLeft = `${offset}%`;
        }
        const isWeekendDisabled = (day === 6 || day === 7) && !this.enableWeekends;
        if (this.date.getTime() <= this.todaysDate.getTime() - 1 || isWeekendDisabled) newDay.classList.add("Calendar-date--disabled");else {
          newDay.classList.add("Calendar-date--active");
          newDay.setAttribute("data-calendar-status", "active");
        }
        if (this.date.toString() === this.todaysDate.toString()) newDay.classList.add("Calendar-date--today");
        newDay.appendChild(dateEl);
        this.month.appendChild(newDay);
      },
      createDateListener() {
        this.activeDates = this.month.querySelectorAll('[data-calendar-status="active"]');
        this.activeDates.forEach(date => {
          date.addEventListener("click", () => {
            this.clearSelected();
            date.classList.add("Calendar-date--selected");
            this.saveDate(`${date.getAttribute("data-calendar-date")}.${this.date.getMonth() + 1}.${this.date.getFullYear()}`);
          });
        });
      },
      switchMonth(direction) {
        this.clearCalendar();
        const nextMonth = direction === "next" ? this.date.getMonth() + 1 : this.date.getMonth() - 1;
        this.date.setMonth(nextMonth);
        this.createMonth();
      },
      createMonth() {
        const currentMonth = this.date.getMonth();
        while (this.date.getMonth() === currentMonth) {
          this.createDay(this.date.getDate(), this.date.getDay(), this.date.getFullYear());
          this.date.setDate(this.date.getDate() + 1);
        }

        // while loop trips over and day is at 30/31, bring it back
        this.date.setDate(1);
        this.date.setMonth(this.date.getMonth() - 1);
        this.label.innerHTML = `${this.monthsAsString(this.date.getMonth())} ${this.date.getFullYear()}`;
        this.createDateListener();
      },
      monthsAsString(monthIndex) {
        const monthMap = {
          0: this.label.getAttribute("data-month-jan"),
          1: this.label.getAttribute("data-month-feb"),
          2: this.label.getAttribute("data-month-mar"),
          3: this.label.getAttribute("data-month-apr"),
          4: this.label.getAttribute("data-month-may"),
          5: this.label.getAttribute("data-month-jun"),
          6: this.label.getAttribute("data-month-jul"),
          7: this.label.getAttribute("data-month-aug"),
          8: this.label.getAttribute("data-month-sep"),
          9: this.label.getAttribute("data-month-oct"),
          10: this.label.getAttribute("data-month-nov"),
          11: this.label.getAttribute("data-month-dec")
        };
        return monthMap[monthIndex];
      },
      saveDate(date) {
        if (this.input) {
          this.input.value = date;
          if (date) {
            this.input.nextElementSibling.classList.add("is-focused");
            this.closeCalendar();
            this.input.dispatchEvent(new CustomEvent("change"));
          }
        }
      },
      clearCalendar() {
        this.month.innerHTML = "";
      },
      clearSelected() {
        this.activeDates.forEach(date => {
          date.classList.remove("Calendar-date--selected");
        });
        this.saveDate("");
      }
    };
    Object.create(calendarObject).init(elementId);
  }
};
$(window).ready(function () {
  var datepickers = $(".js-calendar");
  datepickers.each(function () {
    A1Datepicker.init(this.getAttribute("id"));
  });
});

/**
 * A1 Dropdown Component
 *
 * Use: A1EcomUtil.Dropdown
 */

var A1Dropdown = {
  dropdowns: fetchDropdowns(),
  init() {
    try {
      dropdown().init(false);
    } catch (ex) {
      console.error(ex);
    }
  },
  generate() {
    try {
      var dropdownFunct = dropdown();
      dropdownFunct.generate();
      dropdownFunct.init(true);
    } catch (ex) {
      console.error(ex);
    }
  },
  generateOne(element) {
    if (!element) return;
    try {
      var dropdownFunct = dropdown();
      dropdownFunct.generateOne(element);
      dropdownFunct.init(true);
    } catch (ex) {
      console.error(ex);
    }
  }
};

// On ready
A1Dropdown.init();
function fetchDropdowns() {
  return document.querySelectorAll(".js-dropdown");
}
function dropdown() {
  const checkEventType = e => {
    const event = e || window.event;
    if (event.type === "click") return true;else if (event.type === "keypress" && (event.keyCode === 13 || event.keyCode === 32)) return true;
    return false;
  };
  const handleActiveSelectedState = (select, options, activeNodeData) => {
    let selectedValue = null;
    options.forEach(option => {
      if (option.value === activeNodeData) {
        option.selected = true;

        // Select true must be explicit because IE10/11
        option.setAttribute("selected", "true");
        selectedValue = option.value;
      }
    });
    select.value = selectedValue;
    select.dispatchEvent(new CustomEvent("change"));
  };

  // Select managing/handling
  const setActiveSelectItem = (context, activeNode) => {
    if (!context.previousElementSibling) return;
    const selectElement = context.previousElementSibling;
    const optionsNodeList = selectElement.querySelectorAll("option");
    const options = Array.prototype.slice.call(optionsNodeList);
    if (activeNode) {
      const activeNodeData = activeNode.querySelector(".Dropdown-link").getAttribute("data-value");
      handleActiveSelectedState(selectElement, options, activeNodeData);
    }
  };
  const changeActiveSelectItem = data => {
    if (!getClosest(data, ".js-dropdown").previousElementSibling) return;
    const activeListItem = data;
    const activeNodeData = data.querySelector(".Dropdown-link").getAttribute("data-value");
    const getSelectElement = getClosest(activeListItem, ".js-dropdown").previousElementSibling;
    const optionsNodeList = getSelectElement.querySelectorAll("option");
    const options = Array.prototype.slice.call(optionsNodeList);
    const activeOptions = options.filter(option => option.selected);
    activeOptions.forEach(activeOption => {
      activeOption.selected = false;
      activeOption.removeAttribute("selected");
    });
    handleActiveSelectedState(getSelectElement, options, activeNodeData);
  };

  // Show/hide dropdowns, rotate arrow icon
  const toggleDropdown = element => {
    element.stopPropagation();
    const currentElement = element.currentTarget;
    const dropdownElement = currentElement.nextElementSibling;
    const isOpened = dropdownElement.classList.contains("Dropdown-list--active");
    closeDropdowns();
    if (isOpened) {
      return;
    }
    const icon = currentElement.querySelector(".icon-wrapper");
    icon.classList.toggle("DropdownIcon--rotated");
    dropdownElement.classList.toggle("Dropdown-list--active");
  };

  // Set list item icon
  const setIcon = (button, item) => {
    const buttonIcon = button.querySelector(".Dropdown-icon");
    const nodeIcon = item.querySelector(".Dropdown-icon");
    if (!buttonIcon || !nodeIcon) {
      return;
    }
    buttonIcon.innerHTML = nodeIcon.innerHTML;
  };
  const setNote = (buttonTitle, item) => {
    const nodeNote = item.querySelector(".Dropdown-note");
    if (nodeNote !== null) {
      if (nodeNote.textContent && nodeNote.textContent.length > 0) {
        buttonTitle.textContent += ` ${nodeNote.textContent}`;
      }
    }
  };

  // Get active item
  const getActiveContent = context => {
    const list = context.querySelector(".Dropdown-list");
    const listItems = list.querySelectorAll(".Dropdown-listItem");
    const button = list.previousElementSibling;
    const buttonElement = button.querySelector(".Dropdown-title");
    const buttonText = buttonElement;
    let activeElement = null;

    // Loop all list elements in dropdown and search for one that have 'active' class and check his text content
    listItems.forEach(listItem => {
      if (listItem.classList.contains("active")) {
        buttonText.textContent = listItem.querySelector(".Dropdown-link").querySelector(".Dropdown-value").textContent;
        setNote(buttonText, listItem);
        setIcon(button, listItem);
        activeElement = listItem;
      }
    });
    return activeElement;
  };

  // Change active text value while clicking on dropdown list elements
  // @todo: rewrite function arguments with Rest Parameters
  const changeActiveContent = (nodeElement, nodeTitle, nodeSuptitle) => {
    const list = nodeElement.parentNode;
    const button = list.previousElementSibling;
    const buttonTitle = button.querySelector(".Dropdown-title");
    const buttonSuptitle = button.querySelector(".Dropdown-suptitle");
    buttonTitle.textContent = nodeTitle.textContent.trim();
    if (null != nodeTitle.getElementsByClassName('price-full2')[0]) {
      buttonTitle.textContent = nodeTitle.getElementsByTagName('option')[0].innerText;
      buttonTitle.appendChild(nodeTitle.getElementsByClassName('price-full2')[0].cloneNode(true));
    }
    if (nodeSuptitle !== null) if (nodeSuptitle.textContent && nodeSuptitle.textContent.length > 0) buttonSuptitle.textContent = nodeSuptitle.textContent.trim();
    setNote(buttonTitle, nodeElement);
    setIcon(button, nodeElement);
  };

  // change active state by click on list item
  const changeActiveState = listItems => {
    // check for event - if is keypress event and if is space or enter entered
    const eventType = checkEventType(listItems);
    if (!eventType) return;
    const listItem = listItems.currentTarget;
    const listItemTitle = listItem.querySelector(".Dropdown-link").querySelector(".Dropdown-value");
    const listItemSuptitle = listItem.querySelector(".Dropdown-link").querySelector(".Dropdown-metaValue") || null;
    const listNodeItemSiblings = getSiblings(listItem);
    const listItemSiblings = Array.prototype.slice.call(listNodeItemSiblings);

    // Filter all sibling element that contain active class ( it should be always only one active element )
    const listItemSiblingsActive = listItemSiblings.filter(filterElem => filterElem.classList.contains("active"));

    // if is clicked current 'active' element, return from function
    if (listItem.classList.contains("active")) {
      closeDropdowns();
      return;
    }
    listItem.classList.add("active");
    listItemSiblingsActive.forEach(siblingElement => siblingElement.classList.remove("active"));

    // change active select > option item - pass active item to function
    changeActiveSelectItem(listItem);

    // pass list item node && text values
    changeActiveContent(listItem, listItemTitle, listItemSuptitle);
    closeDropdowns();
  };
  function closeDropdowns() {
    fetchDropdowns().forEach(dropdown => {
      if (!dropdown.querySelector(".Dropdown-list").classList.contains("Dropdown-list--active")) return;
      dropdown.querySelector(".Dropdown-list").classList.remove("Dropdown-list--active");
      dropdown.querySelector(".Dropdown-iconWrapper").classList.remove("DropdownIcon--rotated");
    });
  }
  function init(dynamic) {
    // Loop each dropdown and attach toggleDropdown function
    var dropdownsList;

    /* Check if initializing dynamically added dropdowns */
    if (dynamic) dropdownsList = rootElement.querySelectorAll(".select-dropdown .js-dropdown.Dropdown:not(.initialized)");else dropdownsList = rootElement.querySelectorAll(".js-dropdown.Dropdown:not(.initialized)");
    dropdownsList.forEach(function (currDropdown) {
      var rootDropdownItems = currDropdown.querySelectorAll(".Dropdown-listItem");
      var rootDropdownTrigger = currDropdown.querySelector(".js-dropdownTrigger");
      var rootActions = ["click", "keypress"];
      currDropdown.classList.add("initialized");

      // Check if any list item has active class, if has, change active item title, if doesnt have, dont do anything
      //var rootActiveDropdownItem = getActiveContent(rootElement)

      // set active select option
      //setActiveSelectItem(rootElement, rootActiveDropdownItem)

      // Show dropdown
      rootDropdownTrigger.addEventListener("click", toggleDropdown, false);

      // Click/keypress(space/enter) on dropdown items
      rootActions.forEach(action => {
        rootDropdownItems.forEach(dropdownItem => dropdownItem.addEventListener(action, changeActiveState, false));
      });

      // CLose dropdown when clicking outside of the element
      document.documentElement.addEventListener("click", event => {
        document.querySelectorAll(".Dropdown-list").forEach(dropdownList => {
          dropdownList.parentElement.classList.remove("active");
          dropdownList.parentElement.querySelector(".Dropdown-iconWrapper").classList.remove("DropdownIcon--rotated");
          dropdownList.classList.remove("Dropdown-list--active");
        });
      });
      document.querySelectorAll(".Dropdown-list").forEach(dropdownList => {
        dropdownList.addEventListener("click", event => event.stopPropagation());
      });
    });
  }

  /* Generate dropdowns */

  function createMainButton(rootElement, select) {
    var buttonDiv = document.createElement("div");
    buttonDiv.setAttribute("class", "js-dropdown Dropdown");
    buttonDiv.setAttribute("aria-hidden", "true");
    var button = document.createElement("button");
    button.setAttribute("type", "button");
    var selectLabel = select.getAttribute("label");
    var placeholderLabel = select.getAttribute("placeholder");
    var selectValue = placeholderLabel || select.options[select.selectedIndex].innerHTML || "";
    var buttonHTML = "";
    var buttonClasses = "js-dropdownTrigger Dropdown-label";
    if (selectLabel) {
      buttonHTML += '<span class="Dropdown-suptitle">' + selectLabel + "</span>";
      buttonClasses += " hasSuptitle";
    }
    buttonHTML += '<span class="Dropdown-title">' + selectValue + '</span><span class="icon-wrapper Dropdown-iconWrapper"><div class="toggle"><span class="icon a1icon-arrow-down"></span></div></span>';
    button.setAttribute("class", buttonClasses);
    button.setAttribute("tabindex", "0");
    button.innerHTML = buttonHTML;
    buttonDiv.appendChild(button);
    rootElement.appendChild(buttonDiv);
    return buttonDiv;
  }
  function createItemsList(rootElement, select) {
    var list = document.createElement("ul");
    list.setAttribute("class", "Dropdown-list");
    list.setAttribute("data-toggle-group-class", "");
    list.setAttribute("data-toggle-item-value", "");
    var currOption = null;
    var currItem = null;
    var currItemClass = "";
    var listItemHTML;

    //for each item in select
    for (let j = 0; j < select.length; j++) {
      currOption = select.options[j];
      if (!currOption.innerHTML || currOption.getAttribute("data-placeholder")) continue;
      currItem = document.createElement("li");
      currItemClass = "Dropdown-listItem";
      if (currOption.innerHTML == select.options[select.selectedIndex].innerHTML) currItemClass += " active";
      currItem.setAttribute("class", currItemClass);
      listItemHTML = '<span class="Dropdown-link" data-value="#VAL#" tabindex="0"><span class="Dropdown-value">#TEXT#</span><br><span class="icon-wrapper"><span class="icon a1icon-check"></span></span></span>';
      currItem.innerHTML = listItemHTML.replace("#TEXT#", currOption.innerHTML).replace("#VAL#", currOption.getAttribute("value"));
      list.appendChild(currItem);
    }
    rootElement.appendChild(list);
  }
  function generateDropdown(element) {
    var select = element.getElementsByTagName("select")[0];
    if (element && (!element.nextElementSibling || !element.nextElementSibling.className == "js-dropdown Dropdown")) {
      var mainButton = createMainButton(element, select);
      createItemsList(mainButton, select);
    }
  }
  function generateDropdowns() {
    var dropdowns = document.getElementsByClassName("select-dropdown");
    for (let i = 0; i < dropdowns.length; i++) {
      var select = dropdowns[i].getElementsByTagName("select")[0];
      if (select && (!select.nextElementSibling || !select.nextElementSibling.className == "js-dropdown Dropdown")) {
        var mainButton = createMainButton(dropdowns[i], select);
        createItemsList(mainButton, select);
      }
    }
  }
  return {
    init: init,
    generate: generateDropdowns,
    generateOne: generateDropdown
  };
}

/* A1 Expander JS */

"use strict";
class A1Expand {
  element = null;
  contentElement = null;
  eligible = false;
  toggleHandler = null;
  constructor(element) {
    this.element = element;
    if (!element) return;
    this.init();
    if (this.eligible) {
      this.toggleHandler = function (event) {
        if (!this.element.classList.contains("is-expanded")) {
          // toggle on
          this.contentElement.style.height = this.contentElement.scrollHeight + "px";
          this.contentElement.style.opacity = 1;
          this.contentElement.style.visibility = "visible";
        } else {
          // toggle off
          this.contentElement.style.height = "0px";
          this.contentElement.style.opacity = 0;
          this.contentElement.style.visibility = "hidden";
        }
        this.element.classList.toggle("is-expanded");
      }.bind(this);
      this.element.addEventListener("click", this.toggleHandler);
    }
  }
  init() {
    let parentOfElement = this.element.parentNode;
    let children = parentOfElement.childNodes;
    let contentElement = null;
    for (var i = 0; i < children.length; i++) {
      if (children[i].classList && children[i].classList.contains("js-expand-content")) {
        contentElement = children[i];
        break;
      }
    }
    if (contentElement) {
      this.contentElement = contentElement;
      this.eligible = true;
    }
  }
}
(function () {
  var expandElements = document.querySelectorAll(".js-expand");
  if (expandElements && expandElements.length > 0) {
    expandElements.forEach(function (element) {
      new A1Expand(element);
    });
  }
})();

/**
 * Copyright (c) 2000-present Liferay, Inc. All rights reserved.
 *
 * This library is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Lesser General Public License as published by the Free
 * Software Foundation; either version 2.1 of the License, or (at your option)
 * any later version.
 *
 * This library is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Lesser General Public License for more
 * details.
 */

/* A1 FAQ Expander JS */

"use strict";
class A1FAQExpander {
  element = null;
  expanderItems = null;
  toggleHandler = null;
  constructor(element) {
    if (!element || element.classList.contains("initialized") || element.getAttribute("data-no-js")) return;
    this.element = element;
    this.handleExpanderItemClick = function (event) {
      const target = event.target;
      if (!target.classList.contains("expander-itemTitle")) return;
      this.toggleExpanderItem(event.currentTarget);
    }.bind(this);
    this.init();
  }
  init() {
    // gets element expander
    this.expanderItems = this.element.querySelectorAll(".expander-items .expander-item");
    for (let i = 0; i < this.expanderItems.length; i += 1) {
      this.expanderItems[i].addEventListener("click", this.handleExpanderItemClick);
    }
    this.element.classList.add("initialized");
  }
  toggleExpanderItem(expanderItem) {
    if (expanderItem.classList.contains("expander-item--noDropdown")) return;
    for (let i = 0; i < this.expanderItems.length; i += 1) {
      // Remove "is-active" from all items except for the current clicked item.
      if (this.expanderItems[i] !== expanderItem) this.expanderItems[i].classList.remove("is-active");

      // set height: 0px to each content item

      let contentItem = this.expanderItems[i].querySelector(".expander-itemContent");
      contentItem.style.height = "0px";
    }
    if (expanderItem.classList.contains("is-active")) {
      expanderItem.classList.remove("is-active");
    } else {
      expanderItem.classList.add("is-active");

      // set height of scroll height to content item
      let contentItem = expanderItem.querySelector(".expander-itemContent");
      contentItem.style.height = contentItem.scrollHeight + 20 + "px";
    }
  }
  openAll() {
    for (let i = 0; i < allExpanderItemElements.length; i += 1) {
      if (!allExpanderItemElements[i].classList.contains("is-active")) {
        allExpanderItemElements[i].classList.add("is-active");
      }
    }
  }
  closeAll() {
    for (let i = 0; i < allExpanderItemElements.length; i += 1) {
      allExpanderItemElements[i].classList.remove("is-active");
    }
  }
}
(function () {
  var expandElements = document.querySelectorAll(".expander");
  if (expandElements && expandElements.length > 0) {
    expandElements.forEach(function (element) {
      new A1FAQExpander(element);
    });
  }
})();
var A1FBUtil = {
  ca_purchase(transactionId) {
    $.ajax({
      url: '/o/behe/p/' + transactionId,
      type: 'GET',
      headers: {
        '_originUrlEnc': btoa(window.location)
      },
      contentType: false
    });
  },
  ca_initCheckout(transactionId) {
    $.ajax({
      url: '/o/behe/ic/' + transactionId,
      type: 'GET',
      headers: {
        '_originUrlEnc': btoa(window.location)
      },
      contentType: false
    });
  },
  ca_addToCart(productId) {
    $.ajax({
      url: '/o/behe/atc/' + productId,
      type: 'GET',
      headers: {
        '_originUrlEnc': btoa(window.location)
      },
      contentType: false
    });
  }
};
// Utility functions for Google Tag Manager
var A1GtmUtil = {
  // Advanced Ecommerce
  ae_createProduct(productId, brand, name, variant, price, category) {
    var product = {};
    if (productId) product.id = productId;
    if (brand) product.br = brand;
    if (name) product.name = name;
    if (variant) product.variant = variant;
    if (price) product.price = price;
    if (category) product.category = category;
    if (product.id || product.name) {
      return product;
    }
    return null;
  },
  ae_createProductImpression(productId, brand, name, variant, price, category, list, position) {
    var product = this.ae_createProduct(productId, brand, name, variant, price, category);
    if (product) {
      if (list) product.list = list;
      if (position) product.position = position;
      return product;
    }
    return null;
  },
  ae_createPromotion(promoId, name, creative, position) {
    return {
      'id': promoId,
      'name': name,
      'creative': creative,
      'position': position
    };
  },
  ae_cartAdd(productId, brand, name, variant, price, category) {
    dataLayer.push({
      ecommerce: null
    });
    dataLayer.push({
      'event': 'addToCart',
      'ecommerce': {
        'currencyCode': 'EUR',
        'add': {
          'products': [{
            'name': name,
            'id': productId,
            'price': price,
            'brand': brand,
            'category': category,
            'variant': variant,
            'quantity': 1
          }]
        }
      }
    });
  },
  ae_cartRemove(productId, brand, name, variant, price, category) {
    dataLayer.push({
      ecommerce: null
    });
    dataLayer.push({
      'event': 'removeFromCart',
      'ecommerce': {
        'remove': {
          'products': [{
            'name': name,
            'id': productId,
            'price': price,
            'brand': brand,
            'category': category,
            'variant': variant,
            'quantity': 1
          }]
        }
      }
    });
  },
  ae_checkout(step, option, products) {
    dataLayer.push({
      ecommerce: null
    });
    dataLayer.push({
      'event': 'checkout',
      'ecommerce': {
        'checkout': {
          'actionField': {
            'step': step,
            'option': option
          },
          'products': products.filter(function (val) {
            return val !== null;
          })
        }
      }
    });
  },
  ae_purchase(transactionId, revenue, tax, shipping, coupon, affiliation, products) {
    dataLayer.push({
      ecommerce: null
    });
    dataLayer.push({
      'ecommerce': {
        'purchase': {
          'actionField': {
            'id': transactionId,
            'affiliation': affiliation,
            'revenue': revenue,
            'tax': tax,
            'shipping': shipping,
            'coupon': coupon
          },
          'products': products.filter(function (val) {
            return val !== null;
          })
        }
      }
    });
  },
  ae_impressions(products) {
    dataLayer.push({
      ecommerce: null
    });
    dataLayer.push({
      'ecommerce': {
        'currencyCode': 'EUR',
        'impressions': products.filter(function (val) {
          return val !== null;
        })
      }
    });
  },
  ae_clicks(list, products) {
    dataLayer.push({
      ecommerce: null
    });
    dataLayer.push({
      'event': 'productClick',
      'ecommerce': {
        'click': {
          'actionField': {
            'list': list
          },
          'products': products.filter(function (val) {
            return val !== null;
          })
        }
      }
    });
  },
  ae_detailView(list, product) {
    dataLayer.push({
      ecommerce: null
    });
    dataLayer.push({
      'ecommerce': {
        'detail': {
          'actionField': {
            'list': list
          },
          'products': [product]
        }
      }
    });
  },
  ae_promoView(promotions) {
    dataLayer.push({
      ecommerce: null
    });
    dataLayer.push({
      'ecommerce': {
        'promoView': {
          'promotions': promotions
        }
      }
    });
  },
  ae_promoClick(promotion) {
    dataLayer.push({
      ecommerce: null
    });
    dataLayer.push({
      'event': 'promotionClick',
      'ecommerce': {
        'promoClick': {
          'promotions': [promotion]
        }
      }
    });
  }
};
var A1Lightbox = {
  root: $(".a1lightbox"),
  container: $(".a1lightbox .content"),
  openButtons: $(".a1lightbox-btn"),
  init() {
    let self = this;
    let prevButton = this.root.find(".prev");
    let nextButton = this.root.find(".next");
    let closeButton = this.root.find(".close");
    closeButton.on("click", function (e) {
      self.close();
    });
    prevButton.on("click", function (e) {
      self.previousSlide();
    });
    nextButton.on("click", function (e) {
      self.nextSlide();
    });

    //events
    this.openButtons.on("click", function (e) {
      let slideIndex = $(this).attr("data-image-index");
      if (slideIndex) {
        self.open(slideIndex);
      }
    });
    clickOutside(this.container[0], e => {
      if (this.root.attr("data-open") && this.root.attr("data-open") == "true" && !e.target.classList.contains("a1lightbox-btn")) {
        self.close();
      }
    });
  },
  open(index) {
    let slide = this.root.find(".content .slide");
    if (slide[index]) {
      this.root.attr("data-active-slide", index);
      this.root.attr("data-open", "true");
      $(slide[index]).addClass("active");
      this.root.show();
    }
  },
  close() {
    let slides = this.root.find(".content .slide");
    this.root.attr("data-open", "false");
    slides.removeClass("active");
    this.root.hide();
  },
  totalCountSlides() {
    return this.root.find(".content .slide").length;
  },
  switchSlide(index) {
    let slides = this.root.find(".content .slide");
    slides.removeClass("active");
    $(slides[index]).addClass("active");
    this.root.attr("data-active-slide", index);
  },
  nextSlide() {
    let activeSlide = parseInt(this.root.attr("data-active-slide"));
    let newSlide = this.totalCountSlides() - 1 > activeSlide ? activeSlide + 1 : 0;
    this.switchSlide(newSlide);
  },
  previousSlide() {
    let activeSlide = parseInt(this.root.attr("data-active-slide"));
    let newSlide = activeSlide > 0 ? activeSlide - 1 : this.totalCountSlides() - 1;
    this.switchSlide(newSlide);
  }
};

/*
    Component: A1 Loader

    Use example: 
    let loader = new A1Loader('.selector')                              // loader will be shown within the selector element
    let loader = new A1Loader($('.selector'))                           // loader will be shown within the selector element
    let loader = new A1Loader(document.querySelector('.selector'))      // loader will be shown within the selector element
    let loader = new A1Loader()                                         // loader will be shown within the whole container

    Methods:
    loader.show()       // shows loader
    loader.hide()       // hides loader if exist
*/

class A1Loader {
  loadingElement = null;
  loading = false;
  fixed = false;
  constructor(element, fixed = false) {
    if (element instanceof jQuery) {
      this.loadingElement = element[0];
    } else if (element instanceof Element) {
      this.loadingElement = element;
    } else {
      this.loadingElement = rootElement.querySelector(element) || rootElement;
    }
    this.fixed = fixed;
  }
  show() {
    if (!this.loading) {
      var div = document.createElement("div");
      if (this.fixed) div.style.position = "fixed";
      div.classList.add("loading-overlay");
      div.innerHTML = '<div class="overlay"></div><div class="loading"></div>';
      this.loadingElement.style.position = "relative";
      this.loadingElement.append(div);
    }
    this.loading = true;
  }
  hide() {
    let loaderEl = this.loadingElement.querySelector(".loading-overlay");
    if (loaderEl) {
      this.loadingElement.style.removeProperty("position");
      loaderEl.remove();
    }
    this.loading = false;
  }
}
var A1Navigation = {
  init: function () {
    let leaveTimeout, hoverTimeout;
    let menuItems = $(".navigation .links .links-item");
    let overlay = $(".a1-content-overlay");
    let searchBox = $(".a1-search-popup");
    menuItems.on("mouseenter", function () {
      let menuItem = $(this);
      if (!hoverTimeout) {
        hoverTimeout = setTimeout(function () {
          clearTimeout(leaveTimeout);
          hoverTimeout = null;
          menuItems.removeClass("active");
          menuItem.addClass("active");
          overlay.show();
        }, 200);
      }
    });
    menuItems.on("mouseleave", function () {
      var menuItem = $(this);
      if (!menuItem.hasClass("active")) {
        clearTimeout(hoverTimeout);
        hoverTimeout = null;
      }
      leaveTimeout = setTimeout(function () {
        // check if cursor is not on submenu anymore
        if (!menuItem.is(":hover")) {
          menuItem.removeClass("active");
        }
        if (!menuItems.hasClass("active") && !searchBox.hasClass("active")) {
          overlay.hide();
        }
      }, 1000);
    });

    // CLick outside - close navigation
    overlay.click(function () {
      menuItems.removeClass("active");
      overlay.hide();
    });
  }
};
try {
  A1Navigation.init();
} catch (ex) {
  console.error(ex);
}

/* TODO Mobile navigation spravi v zgornji namespace / init */

function toggleMobileNavigation() {
  var navMobile = $(".main-navigation .navigation-mobile");
  var mainNavi = $(".main-navigation");
  navMobile.toggleClass("is-active");

  //set top position of scroll on mobile devices
  if (window.innerWidth < 576) {
    navMobile.css("top", document.documentElement.scrollTop + (mainNavi.height() - 1) + "px");
  } else {
    navMobile.css("top", "initial");
  }
  const body = $("#content");
  body.toggleClass("no-scroll");
}
$(window).ready(function () {
  $("#toggleMobileNavigation").on("click", function (event) {
    $(this).closest(".navigation-hamburger").toggleClass("is-active");
    toggleMobileNavigation();
  });
  $(".main-navigation-mobile .nav-item").on("click", function (event) {
    let element = $(this).find(".js-navi-open-sublinks");
    let turnedOn = element.hasClass("is-expanded");

    // ignore when clicking on sublinks
    if (!event.target.classList.contains("js-navi-open-sublinks") && !element[0].contains(event.target)) return;

    //close other items
    $(".js-navi-open-sublinks").removeClass("is-expanded");
    $(".nav-list-sublinks").removeClass("is-expanded");

    //open this one
    if (!turnedOn) {
      element.addClass("is-expanded");
      element.next().addClass("is-expanded");
    }
  });
  let searchPopup = $(".a1-search-popup");
  let navItems = $(".navigation .links .links-item");
  let overlay = $(".a1-content-overlay");
  function showSearchPopup() {
    overlay.show();
    navItems.hide();
    searchPopup.addClass("active");
    setTimeout(function () {
      searchPopup.find("input#search-input").focus();
    }, 250);
  }
  function closeSearchPopup() {
    overlay.hide();
    navItems.show();
    searchPopup.removeClass("active");
  }
  $("#searchNavBtn").on("click", function () {
    if (searchPopup.hasClass("active")) {
      closeSearchPopup();
    } else {
      showSearchPopup();
    }
  });
  if (searchPopup && searchPopup.length > 0) {
    clickOutside(searchPopup[0], e => {
      let triggerSearchBtn = document.querySelector("#searchNavBtn");
      if (!searchPopup.hasClass("active") || e.target === triggerSearchBtn) {
        return;
      }
      closeSearchPopup();
    });
  }
});

/* Order bar helper JS */

/*
    Component: A1 Order Bar

    Use example: 
    let orderBar = new A1OrderBar('.selector')                              // loader will be shown within the selector element
    let orderBar = new A1OrderBar($('.selector'))                           // loader will be shown within the selector element
    let orderBar = new A1OrderBar(document.querySelector('.selector'))      // loader will be shown within the selector element

    Methods:
    orderBar.show()         // shows order bar
    orderBar.hide()         // hides order bar
    orderBar.maximize()     // shows products from order bar
    orderBar.minimize()     // hides products from order bar
*/
"use strict";
class A1OrderBar {
  element = null;
  elementDetails = null;
  elementLeft = null;
  toggleButton = null;
  autoScrollAdjustEnabled = false;
  maximized = true;
  scrollHandler = null;
  toggleHandler = null;
  maximizeEvent = new Event("a1secom.orderbar.maximize");
  minimizeEvent = new Event("a1secom.orderbar.minimize");
  options = {
    cooldown: false,
    delay: 500,
    // ms
    offsetShow: 150,
    // px
    offsetHide: 150 // px
  };
  constructor() {
    this.init();
    if (this.autoScrollAdjustEnabled) {
      this.scrollHandler = function (event) {
        if (this.options.cooldown) return;
        let startPos = window.scrollY;
        var self = this;
        setTimeout(function () {
          let endPos = window.scrollY;
          if (startPos < endPos - self.options.offsetHide) {
            self.minimize();
          } else if (startPos > endPos + self.options.offsetShow) {
            self.maximize();
          }
          self.options.cooldown = false;
        }, self.options.delay);
        self.options.cooldown = true;
      }.bind(this);
      this.toggleHandler = function (event) {
        if (this.maximized) {
          this.minimize();
        } else {
          this.maximize();
        }
      }.bind(this);

      // document.addEventListener("scroll", this.scrollHandler);
      this.toggleButton.addEventListener("click", this.toggleHandler);
    }
  }
  init() {
    this.element = document.querySelector(".order-bar");
    if (!this.element) {
      console.error("Order bar element not found and could not be initialized.");
      return;
    }
    this.toggleButton = this.element.querySelector(".order-bar-toggle");
    if (this.toggleButton) this.maximized = this.toggleButton.classList.contains("active");
    this.elementDetails = this.element.querySelector(".products-container");
    this.elementLeft = this.element.querySelector(".order-bar-left");

    // set auto minimization if order bar details element exists and is mobile
    //if (this.elementDetails && window.outerWidth < 576) {
    if (this.elementDetails) {
      this.autoScrollAdjustEnabled = true;
    }
  }
  resetScrollListeners() {
    if (this.autoScrollAdjustEnabled) {
      this.init();
      // document.removeEventListener("scroll", this.scrollHandler);
      this.toggleButton.removeEventListener("click", this.toggleHandler);

      // document.addEventListener("scroll", this.scrollHandler);
      this.toggleButton.addEventListener("click", this.toggleHandler);
    }
  }
  maximize() {
    this.elementDetails.classList.remove("hidden");
    if (this.elementLeft) this.elementLeft.classList.remove("hidden");
    this.toggleButton.classList.add("active");
    this.maximized = true;
    document.dispatchEvent(this.maximizeEvent);
  }
  minimize() {
    this.elementDetails.classList.add("hidden");
    if (this.elementLeft) this.elementLeft.classList.add("hidden");
    this.toggleButton.classList.remove("active");
    this.maximized = false;
    document.dispatchEvent(this.minimizeEvent);
  }
  show() {
    this.element.classList.remove("hidden");
  }
  hide() {
    this.element.classList.add("hidden");
  }
}
if (document.querySelector(".order-bar")) {
  var orderBarHelper = new A1OrderBar();
}
$(window).ready(function () {
  let focused = "is-focused";
  let inputElements = $(".float-input input,.float-input textarea");
  inputElements.each(function (index) {
    var element = $(this);
    if (element.val()) element.addClass(focused);
  });
  inputElements.on("change", function () {
    let element = $(this);
    if (this.value) element.addClass(focused);else element.removeClass(focused);
  });

  /* Show more button */

  $(".show-more .btn").on("click", function () {
    var self = $(this).parent();
    let opening = true;
    var content = self.find(".content");
    if (self.hasClass("is-shown")) {
      opening = false;
    }
    self.toggleClass("is-shown");
    if (!content) return;
    if (opening) {
      content.css("height", content.prop("scrollHeight") + 20 + "px");
    } else {
      content.css("height", 0 + "px");
    }
  });

  /* Radio check content expander */

  $(".card-radio input.form-check-input:checked").each(function () {
    let el = $(this);
    let parent = el.parent();
    let contentElement = parent.next();

    // if content exists and radio is checked, make content visible

    if (this.checked && contentElement.hasClass("expand-radio-content")) {
      contentElement.css("display", "block");
    }
  });
  $(".card-radio input.form-check-input").change(function () {
    let el = $(this);
    let parent = el.parent();
    let container = parent.parent();
    let contentElement = parent.next();

    // hide all content elements

    let allContentElements = container.find(".expand-radio-content");
    allContentElements.css("display", "none");

    // if content exists and radio is checked, make content visible

    if (this.checked && contentElement.hasClass("expand-radio-content")) {
      contentElement.css("display", "block");
    }
  });
  $(".card-checkbox input.form-check-input").change(function () {
    let el = $(this);
    let parent = el.parent();
    let container = parent.parent();
    let contentElement = parent.next();

    // hide all content elements

    let allContentElements = container.find(".expand-checkbox-content");
    allContentElements.css("display", "none");

    // if content exists and radio is checked, make content visible

    if (this.checked && contentElement.hasClass("expand-checkbox-content")) {
      contentElement.css("display", "block");
    }
  });

  /* Append order bar bottom spacer if order bar exists */
  let orderbar = $(".order-bar")[0];
  if (orderbar) {
    $(".sa1-frame .footer").after('<div class="order-bar-spacer" style="height: ' + orderbar.clientHeight + 'px;"></div>');
  }

  /* Smooth scroll */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      scrollToElement(document.querySelector(this.getAttribute("href")));
    });
  });

  /* Initialize bootstrap tooltips */
  $('[data-toggle="tooltip"]').tooltip();

  /* Initialize bootstrap popovers */
  $('[data-toggle="popover"]').popover();
});

/* Helper util functions - globally available */

var A1Util = {
  formatAmount(amount) {
    let digit = Math.floor(amount + "e" + 2) + "e-" + 2;
    return parseFloat(digit).toLocaleString("sl-SI", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  },
  isBreakpointMobile() {
    return window.innerWidth < 765;
  },
  flyToElement(flyer, flyingTo) {
    var $func = $(this);
    var divider = 6;
    var flyerClone = $(flyer).clone();
    if (!flyerClone.offset()) return;
    $(flyerClone).css({
      position: "absolute",
      top: $(flyer).offset().top + $(flyer).height() / 2 + "px",
      left: $(flyer).offset().left + $(flyer).width() / 2 + "px",
      width: 200 + "px",
      opacity: 1,
      "z-index": 1000
    });
    $("body").append($(flyerClone));
    var gotoX = $(flyingTo).offset().left + $(flyingTo).width() / 2 - $(flyer).width() / divider / 2 - 7;
    var gotoY = $(flyingTo).offset().top + 20;
    $(flyerClone).animate({
      opacity: 0.7,
      left: gotoX,
      top: gotoY,
      width: 42,
      height: 40
    }, 600, function () {
      $(flyingTo).fadeOut("fast", function () {
        $(flyingTo).fadeIn("fast", function () {
          $(flyerClone).fadeOut("fast", function () {
            $(flyerClone).remove();
          });
        });
      });
    });
  },
  initInputs() {
    let inputElements = $(".float-input input,.float-input textarea");
    inputElements.each(function (index) {
      var element = $(this);
      if (element.val()) element.addClass("is-focused");
    });
    inputElements.on("change", function () {
      let element = $(this);
      if (this.value) element.addClass("is-focused");else element.removeClass("is-focused");
    });
  }
};